<template>
  <div class="body">
    <div class="timerBox">
      <p>{{ atitle }}</p>
    </div>
    <div class="main">
      <div class="progress">
        <div id="myChart" class="chart"></div>
        <div class="progress_info">
          <span class="rate">
            <span class="big">{{ score }}</span>
            <span class="small">分</span>
          </span>
          <p class="p_text">满分{{ all_score }}分</p>
          <hr class="line">
          <p class="count">共<span style="color:#ee2e2e;">{{ count }}</span>题</p>
        </div>
      </div>
      <div class="content">
        <p class="txt1">评测名称：{{ doResult.title }}</p>
        <p v-if="obj_type!=3" class="txt2">恭喜你~你已赶超<span style="color:#ee2e2e;">{{ beyond }}</span>的学员，要继续努力呀</p>
      </div>
    </div>
    <div class="footer">
      <van-button color="#ee2e2e" @click="backLesson">返回课表</van-button>
      <van-button v-if="review_type!=3" color="#ee2e2e" @click="reviewAgin">重新评测</van-button>
      <van-button v-if="review_type!=4" color="#ee2e2e" @click="lookAnalysis">查看解析</van-button>
      <!-- <van-button v-if="review_type!=4 && doResult.sms" color="#ee2e2e" @click="getBaogao">领取报告</van-button> -->
    </div>
  </div>
</template>

<script>
import { newGetresult } from '@/api/evaluation.js'
import tool from '@/utils/tools.js'
import cookies from 'js-cookie'
export default {
  data() {
    return {
      atitle: '评测结果',
      review_id: '',
      lesson_id: this.$route.query.lesson_id || '',
      result_id: this.$route.query.result_id || '',
      obj_type: this.$route.query.obj_type || '',
      exam_name: '',
      review_type: '',
      beyond: '',
      is_buy: 0,
      rate: 0,
      score: 0,
      count: 0,
      all_score: 0,
      doResult: {
        title: '评测结果'
      }
    }
  },
  created() {
    this.getPageDatas()
  },
  mounted() {
    this.$nextTick(() => {
      this.makeEchart()
    })
  },
  methods: {
    // 回到课程
    backLesson() {
      if (tool.isInApp()) {
        const name = cookies.get('lesson_name') || ''
        const str = 'index=0' + '&lesson_id=' + this.lesson_id + '&lesson_name=' + name
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_openTabbar.postMessage(encodeURIComponent(str))
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_openTabbar'
            , str
            , function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        this.$router.push('/')
      }
    },
    // 页面数据
    getPageDatas() {
      const info1 = {
        result_id: this.result_id
      }
      newGetresult(info1).then(res => {
        const errNo = res.errNo
        if (errNo === 0) {
          const data = res.result || {}
          console.log(this.doResult)
          this.review_id = data.exam_id
          this.is_buy = data.is_buy || 0
          this.exam_name = data.title || ''
          this.review_type = data.type || ''
          this.beyond = data.beyond || '0%'
          this.score = data.score || 0
          this.all_score = data.score_count || 0
          this.count = data.question_count || 0
          this.doResult = data
          // 计算百分比
          const all_s = parseInt(this.all_score)
          if (all_s > 0) {
            const score = this.score > all_s ? all_s : this.score
            this.rate = parseInt(((score * 1.0) / all_s) * 100)
          } else {
            this.rate = 0
          }
          this.makeEchart()
          // 设置title标题
          const my_title = document.getElementsByTagName('title')[0]
          my_title.innerHTML = this.doResult.title
        } else {
          this.$toast(res.msg)
        }
      })
    },
    makeEchart() {
      var myChart = this.$echarts.init(document.getElementById('myChart'))
      myChart.resize({
        width: 'auto',
        height: 220
      })
      // 指定图表的配置项和数据
      var option = {
        angleAxis: {
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          min: 0,
          max: 133.5,
          boundaryGap: ['0', '100'],
          startAngle: 225
        },
        radiusAxis: {
          type: 'category',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          data: ['a', 'b', 'c'],
          z: 10
        },
        polar: {
          radius: '90%'
        },
        series: [
          {
            type: 'bar',
            data: [0, 0, this.rate],
            coordinateSystem: 'polar',
            barMaxWidth: 10,
            z: 2,
            roundCap: true,
            color: '#ee2e2e',
            barGap: '100%'
          },
          {
            type: 'bar',
            data: [0, 0, 100],
            z: 0,
            silent: true,
            coordinateSystem: 'polar',
            barMaxWidth: 10,
            name: 'C',
            roundCap: true,
            color: '#eee',
            barGap: '-100%'
          }
        ],
        tooltip: {
          show: false
        }
      }
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
      window.onresize = myChart.resize
    },
    // 重新评测
    reviewAgin() {
      sessionStorage.removeItem('paperLists')
      this.$router.push({
        path: '/exerciseMode',
        query: {
          review_id: this.review_id,
          lesson_id: this.lesson_id,
          obj_type: this.obj_type
        }
      })
    },
    // 查看解析
    lookAnalysis() {
      if (this.review_type == 4) return
      this.$router.push({
        path: '/analysis',
        query: {
          result_id: this.result_id
        }
      })
    },
    // 领取报告
    getBaogao() {
      const url = this.doResult.sms
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.body {
  width: 100%;
  text-align: left;
  background-color: #fff;
}
.topHead {
  position: relative;
}
.timerBox {
  background-color: #fff;
  width: 100%;
  height: 80px;
  position: relative;
  border-bottom: 1px solid #eee;
  p {
    font-family: PingFangSC-Regular;
    color: #333;
    font-size: 32px;
    line-height: 80px;
    text-align: center;
  }
  .counts {
    position: absolute;
    top: 0;
    right: 20px;
    color: #333;
    font-size: 32px;
    line-height: 80px;
  }
}

.main {
  // margin-top: 100px;
  width: 100%;
  background-color: #fff;
  .progress {
    width: 100%;
    position: relative;
    .progress_info {
      width: 100%;
      position: absolute;
      top: 22%;
      height: 240px;
      text-align: center;
      font-family: PingFangSC-Regular, PingFang SC;
      .rate {
        color: #ee2e2e;
        font-family: PingFangSC-Medium, PingFang SC;
        .big {
          font-size: 88px;
        }
        .small {
          font-size: 56px;
        }
      }
      .p_text {
        color: #333333;
        font-size: 36px;
      }
      .line {
        position: absolute;
        left: 50%;
        margin-left: -75px;
        margin-block-start: 5px;
        margin-block-end: 5px;
        width: 140px;
        color: #eeeeee;
        height: 1px;
        border: 0.5px solid #eeeeee;
      }
      .count {
        color: #999999;
        font-size: 28px;
        margin-top: 10px;
      }
    }
  }
  .content {
    padding: 10px 30px;
    font-family: PingFangSC-Regular;
    color: #333;
    line-height: 60px;
    text-align: center;
    .txt1 {
      font-size: 42px;
    }
    .txt2 {
      font-size: 36px;
    }
  }
}

.footer {
  background-color: #fff;
  width: 100%;
  height: 100px;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  /deep/.van-button {
    margin-top: 10px;
    padding: 25px 20px;
    height: 0 !important;
    border-radius: 30px;
    font-size: 28px !important;
    font-family: PingFangSC-Regular;
  }
}
</style>
